import { styled } from '@mui/material';

export const PrimaryRepTabWrapper = styled('div')({
    overflow: 'hidden',
});
